const mainProps = {
  title: '',
  subTitle: '',
  underLine: {
    title: {
      isShow: true,
      width: '70px', // any number with px, compute(bigger than text), full(line/screen)
      color: null
    },
    subTitle: {
      isShow: false,
      width: 'full', // any number with px, compute(bigger than text), full(line/screen)
      color: null
    }
  },
  styleConfig: {
    root: null
    // title: {
    //   fontSize: '32px',
    //   color: '#000'
    // },
    // subTitle: {
    //   fontSize: '14px',
    //   color: '#666666'
    // }
  }
}

const childProps = {
  title: '',
  renderMode: '',
  image: {
    src: ''
  },
  detailLink: {
    isActive: false,
    url: '',
    isInnerPage: true,
    openNewWindow: false
  },
  styleConfig: {
    root: null
    // title: {
    //   fontSize: '16px',
    //   color: '#ffffff'
    // }
  }
}

export default mainProps

export { childProps }
